// import React, { useContext, useEffect, useState } from 'react'
// import { store } from '../../App'
// import { Carousel, Container, Row, Col, Button, Card, Accordion } from 'react-bootstrap';
// import Nav from 'react-bootstrap/Nav';
// import { GiWireframeGlobe } from 'react-icons/gi'
// import NavDropdown from 'react-bootstrap/NavDropdown';
// import GlobalNetworkSection from './Globalcontent';
// import WorldMap from './Globalcontent';
// import { FaArrowRightLong } from "react-icons/fa6";
// import Footer from './Footer';
// import OwlCarousel from 'react-owl-carousel';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';
// import ProjectSection from '../../Owlcarojel';
// import Globalcontent from './Globalcontent';
// import New from '../New';
// import CountUp from 'react-countup';
// import { IoLocationSharp } from "react-icons/io5";
// import { GoProject } from "react-icons/go";
// import { MdOutlinePeople } from "react-icons/md";
// import { IoPricetags } from "react-icons/io5";
// import 'aos/dist/aos.css'; // Import AOS CSS
// import CounterSection from '../CounterSection';
// import AOS from 'aos';
// import MyCarousel from './Carousel';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import { Helmet } from "react-helmet";
// import parse from 'html-react-parser';




// function Hompage() {
//   const [menus, setMenus] = useContext(store);
//   const [option, setOption] = useState()
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   useEffect(() => {
//     AOS.init();
//   }, []);

//   const handleCarouselSlide = () => {
//     AOS.refresh(); // Refresh AOS animations on carousel slide
//   };
//   const options = {
//     items: 3,
//     loop: true,
//     margin: 10,
//     responsive: {
//       0: {
//         items: 1,
//       },
//       600: {
//         items: 2,
//       },
//       1000: {
//         items: 3,
//       },
//     },
//   };

//   const projects = [
//     {
//       image: 'https://www.hyundaielevator.co.kr/upload/image/20180725_174359_870.jpg',
//       category: 'interiors',
//       title: 'Lower River Street Astoria',
//     },
//     {
//       image: 'https://www.hyundaielevator.co.kr/upload/image/20180725_174359_870.jpg',
//       category: 'interiors',
//       title: 'Lower River Street Astoria',
//     },
//     {
//       image: 'https://www.hyundaielevator.co.kr/upload/image/20180725_174359_870.jpg',
//       category: 'interiors',
//       title: 'Lower River Street Astoria',
//     },
//     {
//       image: 'https://www.hyundaielevator.co.kr/upload/image/20180725_174359_870.jpg',
//       category: 'interiors',
//       title: 'Lower River Street Astoria',
//     },

//     // Add more projects as needed
//   ];
//   const myStyle = {
//     transform: 'translate3d(-1233px, 0px, 0px)',
//     transition: 'all 0s ease 0s',
//     width: '4009px',
//   };

//   const [countReached25, setCountReached25] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setCountReached25(true);
//     }, 5750); // Adjust this value according to your CountUp duration

//     return () => clearTimeout(timer);
//   }, []);
//   const handleCountUpEnd = () => {
//     setCountReached25(true);
//   };

//   useEffect(() => {
//     const fetchdata = async () => {
//       try {
//         const response = await axios.get('https://admin.techno-elevators.com/api/getHomePageDataBySlug/home')
//         setData(response.data.data)
//       }
//       catch (err) {
//         setError(err.message);
//       }
//       finally {
//         setLoading(false);
//       }
//     }

//     fetchdata()
//   })
//   return (
//     <>

//       <Helmet>
//         <title>Elevators, Escalators & Travelators in Oman | Techno Elevators LLC</title>
//         <meta name="description" content="Techno Elevators LLC is a leading brand for elevator, escalator and travelators. Get easy installation, repair, modernization &more." />

//       </Helmet>
//       <MyCarousel />
//       {data && data.view_all_business_lines ?

//         <section className="team spad mt-5 " >
//           <Container>
//             <Row>
//               <Col lg={12} md={12} sm={6}>
//                 <div className="section-title mb-4">
//                   <p className='mb-5'>{data.view_all_business_lines.category_title_en}</p>
//                 </div>
//               </Col>
//             </Row>
//             <Row>

//               {data.view_all_business_lines?.sections?.map((item, index) => (
//                 <Col lg={4} md={4} data-aos="zoom-in-up" style={{ paddingLeft: "7px" }} key={index}>
//                   <div
//                     className="team__item set-bg"
//                     style={{ backgroundImage: `url(${item.icon_file_or_image})` }}
//                   >
//                     <div className="team__text">
//                       <div className="team__title">
//                         <h5>{item.section_title_en}</h5>
//                         <span>{item.section_sub_title_en}</span>
//                       </div>
//                       <p>{parse(item.description_en)}</p>

//                       <div className="team__social">
//                         <a href="#"><i className="fa fa-facebook"></i></a>
//                         <a href="#"><i className="fa fa-twitter"></i></a>
//                         <a href="#"><i className="fa fa-instagram"></i></a>
//                       </div>
//                     </div>
//                   </div>
//                 </Col>
//               ))}
//             </Row>
//           </Container>
//         </section >
//         : null}

//       <Container fluid >
//         <Row style={{ display: 'flex', justifyContent: 'center' }}>
//           <Col lg={11}>
//             <section className="services spad ">
//               <div className="container mb-4">
//                 <div className="row">
//                   <div className="col-lg-12 mb-4">
//                     <div className="section-title mt-5 mb-5">
//                       <p>{data?.our_specialization?.category_title_en}</p>

//                       {/* <h2 style={{}}>What we do</h2> */}
//                     </div>
//                   </div>
//                 </div>
//                 <div className="row our_specialization">

//                   {data?.our_specialization?.sections.map((item) => {
//                     return (


//                       <div className="col-lg-3 col-md-6 col-sm-6">


//                         <Link to="elevators">
//                           <div className="services__item text-center">
//                             <img src={item.icon_file_or_image} alt="" width={'65px'} />
//                             <h4 className='mt-1'>{item.section_title_en}</h4>
//                             <p>{parse(item.description_en)}
//                             </p>
//                           </div>
//                         </Link>
//                       </div>
//                     )

//                   })}

                  
//                 </div>
//                 <div className="counter__content">
//                   <div className="row">
//                   </div>
//                 </div>
//               </div>
//             </section>

//           </Col>
//         </Row>
//       </Container>

//       <Container fluid>
//         <Row>
//           <Col lg={12} >
//             <Row style={{ display: 'flex', justifyContent: 'center' }}>
//               <Col lg={9}>
//                 <div>
//                   <h3 className='text-center mt-4 mb-4'>{data?.why_choose_us?.category_title_en}</h3>

//                   {data?.why_choose_us?.sections.map((item)=>{
//                     return(

                  
//                   <Accordion defaultActiveKey={item.id === 0}>
//                     <Accordion.Item eventKey={item.id}>
//                       <Accordion.Header>
//                         <strong>{item.section_title_en}</strong>
//                       </Accordion.Header>
//                       <Accordion.Body>
//                         {parse(item.description_en)}
//                       </Accordion.Body>
//                     </Accordion.Item>

                  
//                   </Accordion>
//                     )
//                   })}

//                 </div>

//               </Col>
//             </Row>

//           </Col>

//         </Row>
//       </Container>

//       <section className="background-image  mt-5" style={{ height: '350px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//         <Container>
//           <Row>
//             <Col lg={12}>
//               <CounterSection />

//             </Col>
//           </Row>
//         </Container>
//       </section>

//       <Footer />
//     </>
//   )
// }

// export default Hompage


import React, { useContext, useEffect, useState, useCallback } from 'react'
import { store } from '../../App'
import { Carousel, Container, Row, Col, Button, Card, Accordion } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import { GiWireframeGlobe } from 'react-icons/gi'
import NavDropdown from 'react-bootstrap/NavDropdown';
import GlobalNetworkSection from './Globalcontent';
import WorldMap from './Globalcontent';
import { FaArrowRightLong } from "react-icons/fa6";
import Footer from './Footer';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import ProjectSection from '../../Owlcarojel';
import Globalcontent from './Globalcontent';
import New from '../New';
import CountUp from 'react-countup';
import { IoLocationSharp } from "react-icons/io5";
import { GoProject } from "react-icons/go";
import { MdOutlinePeople } from "react-icons/md";
import { IoPricetags } from "react-icons/io5";
import 'aos/dist/aos.css'; // Import AOS CSS
import CounterSection from '../CounterSection';
import AOS from 'aos';
import MyCarousel from './Carousel';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import parse from 'html-react-parser';

function Hompage() {
  const [menus, setMenus] = useContext(store);
  const [option, setOption] = useState();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [countReached25, setCountReached25] = useState(false);

  // Initialize AOS
  useEffect(() => {
    AOS.init();
  }, []);

  // Timer to control when count reaches 25
  useEffect(() => {
    const timer = setTimeout(() => {
      setCountReached25(true);
    }, 5750); // Adjust this value according to your CountUp duration

    return () => clearTimeout(timer);
  }, []);

  // Fetching homepage data
  const fetchData = useCallback(async () => {
    try {
      const response = await axios.get('https://admin.techno-elevators.com/api/getHomePageDataBySlug/home');
      setData(response.data.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // AOS refresh handler for carousel slide
  const handleCarouselSlide = () => {
    AOS.refresh();
  };

  // Options for the owl carousel
  const options = {
    items: 3,
    loop: true,
    margin: 10,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 3,
      },
    },
  };

  // Display loading state if data is still fetching
  if (loading) {
    return <div className='loader-header'>
    <span class="loader"></span>
    </div>;
  }

  // Display error message if there is an issue with the data fetching
  if (error) {
    return <div>{error}</div>;
  }

  return (
    <>
      <Helmet>
        <title>Elevators, Escalators & Travelators in Oman | Techno Elevators LLC</title>
        <meta name="description" content="Techno Elevators LLC is a leading brand for elevator, escalator and travelators. Get easy installation, repair, modernization & more." />
      </Helmet>

      <MyCarousel />

      {/* Business Lines Section */}
      {data && data.view_all_business_lines && (
        <section className="team spad mt-5">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="section-title mb-4">
                  <p className='mb-5'>{data.view_all_business_lines.category_title_en}</p>
                </div>
              </Col>
            </Row>
            <Row>
              {data.view_all_business_lines?.sections?.map((item, index) => (
                <Col lg={4} md={4} data-aos="zoom-in-up" style={{ paddingLeft: "7px" }} key={index}>
                  <div
                    className="team__item set-bg"
                    style={{ backgroundImage: `url(${item.icon_file_or_image})` }}
                  >
                    <div className="team__text">
                      <div className="team__title">
                        <h5>{item.section_title_en}</h5>
                        <span>{item.section_sub_title_en}</span>
                      </div>
                      <p>{parse(item.description_en)}</p>
                      <div className="team__social">
                        <a href="#"><i className="fa fa-facebook"></i></a>
                        <a href="#"><i className="fa fa-twitter"></i></a>
                        <a href="#"><i className="fa fa-instagram"></i></a>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      )}

      {/* Our Specialization Section */}
      <Container fluid>
        <Row style={{ display: 'flex', justifyContent: 'center' }}>
          <Col lg={11}>
            <section className="services spad">
              <div className="container mb-4">
                <div className="row">
                  <div className="col-lg-12 mb-4">
                    <div className="section-title mt-5 mb-5">
                      <p>{data?.our_specialization?.category_title_en}</p>
                    </div>
                  </div>
                </div>
                <div className="row our_specialization">
                  {data?.our_specialization?.sections.map((item) => (
                    <div className="col-lg-3 col-md-6 col-sm-6" key={item.id}>
                      <Link to="elevators">
                        <div className="services__item text-center">
                          <img src={item.icon_file_or_image} alt="" width={'65px'} />
                          <h4 className='mt-1'>{item.section_title_en}</h4>
                          <p>{parse(item.description_en)}</p>
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </Col>
        </Row>
      </Container>

      {/* Why Choose Us Section */}
      <Container fluid>
        <Row>
          <Col lg={12}>
            <Row style={{ display: 'flex', justifyContent: 'center' }}>
              <Col lg={9}>
                <h3 className='text-center mt-4 mb-4'>{data?.why_choose_us?.category_title_en}</h3>
                {data?.why_choose_us?.sections.map((item) => (
                  <Accordion defaultActiveKey={item.id === 0} key={item.id}>
                    <Accordion.Item eventKey={item.id}>
                      <Accordion.Header>
                        <strong>{item.section_title_en}</strong>
                      </Accordion.Header>
                      <Accordion.Body>
                        {parse(item.description_en)}
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                ))}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      {/* Counter Section */}
      <section className="background-image mt-5" style={{ height: '350px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Container>
          <Row>
            <Col lg={12}>
              <CounterSection />
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
}

export default Hompage;






